import { API } from 'api';
import { useMutation } from 'react-query';

interface IResetAllEmployeePoints {
  payload: {
    targetEmployerId: string;
    toEid: string;
    description?: string;
  };
}

export const resetAllEmployeePoints = (payload: IResetAllEmployeePoints['payload']) =>
  API.post()(`/api/admin/reward/reset/all`, payload);

export const useResetAllEmployeePoints = () =>
  useMutation(resetAllEmployeePoints, {
    onSuccess: (response) => response.data,
  });
